/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: BpTextFieldWrapper.tsx
 * Project: mle-client
 * Committed last: 2021/11/9 @ 1922
 * ---
 */

import {Field, FieldAttributes} from 'formik';
import React from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';
import {FieldWrapperProps} from "./common";

/**
 * Wrapper per inserire dei campi di testo
 * @param props
 * @constructor
 */
export const BpTextFieldWrapper = (props: FieldWrapperProps) => (
    <Field type={props.type} name={props.name}>
        {({field, meta}: FieldAttributes<any>) => (
            <FormGroup
                className={props.className}
                helperText={meta.touched && meta.error ?
                    <div>{meta.error}</div> : ''}
                intent={meta.touched && meta.error ? 'danger' : 'none'}
                label={props.label}
                labelInfo={props.labelInfo}
            >
                <InputGroup
                    className={props.inputClassName}
                    tabIndex={props.tabIndex}
                    min={props.min ?? ''}
                    max={props.max ?? ''}
                    type={props.type}
                    intent={meta.touched && meta.error ? 'danger' : 'none'} {...field}
                    placeholder={props.placeholder}/>
            </FormGroup>
        )}
    </Field>
);
